import React from "react";
import { Routes, Route, Outlet } from "react-router-dom";
/// Css
import "./index.css";
import "./chart.css";
import "./step.css";

/// Layout
import Nav from "./layouts/nav";

/// Pages
import Error404 from "./common/Error404";

//Scroll To Top
import ScrollToTop from "./layouts/ScrollToTop";

import Dashboard from "./pages/Dashboard";

// AdminSetting
import Permission from "./pages/AdminManagment/CustomRules";
import AddPermission from "./pages/AdminManagment/CustomRules/AddRole";
import Admins from "./pages/AdminManagment/Admin";
import Notification from "./pages/Notification";
import PaymentLink from "./pages/PaymentLink";
import Users from "./pages/Users";
import AddNotification from "./pages/Notification/AddNotification";
import CategoryManagement from "./pages/CategoryManagement";
import Courts from "./pages/Courts";
import Banner from "./pages/CMS/Banner";
import Products from "./pages/MarketPlace /Products";
import AddProduct from "./pages/MarketPlace /Products/AddProduct";
import AllBooking from "./pages/Booking/AllBooking";
import FAQs from "./pages/CMS/FAQs";
import Privacy from "./pages/CMS/Privacy";
import OnBoarding from "./pages/CMS/OnBoarding";
import Matches from "./pages/MarketPlace /Matches";
import AddMatches from "./pages/MarketPlace /Matches/AddMatches";
import Packages from "./pages/Subscription/Packages";
import AddPackage from "./pages/Subscription/Packages/AddPackage";
import UserReports from "./pages/Reports/UserReports";
import MatchesReports from "./pages/Reports/MatchesReports";
import PinMarketPlace from "./pages/MarketPlace /PinMarketPlace";
import BookingRequests from "./pages/Booking/BookingRequests";
import Subscription from "./pages/Subscription/Subscription";
import BookingReports from "./pages/Reports/BookingReports";
import SubscriptionReports from "./pages/Reports/SubscriptionReports";

const Markup = () => {
	const allroutes = [
		// Dashboard
		{ url: "/", component: <Dashboard /> },

		// Staff Managment
		{ url: "/admins", component: <Admins /> },
		{ url: "roles", component: <Permission /> },
		{ url: "roles/add_role", component: <AddPermission /> },
		{ url: "roles/:id", component: <AddPermission /> },

		// Category Managment
		{ url: "category-managment", component: <CategoryManagement /> },

		// Courts
		{ url: "courts", component: <Courts /> },

		// Market Place
		{ url: "products", component: <Products /> },
		{ url: "add-product", component: <AddProduct /> },
		{ url: "matches", component: <Matches /> },
		{ url: "matches/add-matches", component: <AddMatches /> },
		{ url: "pin-market-place", component: <PinMarketPlace /> },

		// Subscription
		{ url: "packages", component: <Packages /> },
		{ url: "add-package", component: <AddPackage /> },
		{ url: "subscription", component: <Subscription /> },

		// Booking
		{ url: "all-booking", component: <AllBooking /> },
		{ url: "booking-requests", component: <BookingRequests /> },

		// Users
		{ url: "/users", component: <Users /> },

		// Reports
		{ url: "/users-reports", component: <UserReports /> },
		{ url: "/matches-reports", component: <MatchesReports /> },
		{ url: "/booking-reports", component: <BookingReports /> },
		{ url: "/subscription-reports", component: <SubscriptionReports /> },

		// CMS
		{ url: "banner", component: <Banner /> },
		{ url: "faqs", component: <FAQs /> },
		{ url: "privacy-policy", component: <Privacy /> },
		{ url: "about-us", component: <Privacy /> },
		{ url: "advertisement-splash", component: <Privacy /> },
		{ url: "onboarding", component: <OnBoarding /> },

		// Notification
		{ url: "notification", component: <Notification /> },
		{ url: "notification/add-notification", component: <AddNotification /> },
		{ url: "notification/edit-notification", component: <AddNotification /> },

		// Payment Link
		{ url: "payment-link", component: <PaymentLink /> },

		// Error
		{ url: "*", component: <Error404 /> },
	];

	return (
		<>
			<Routes>
				<Route path="page-error-404" element={<Error404 />} />
				<Route element={<MainLayout />}>
					{allroutes.map((data, i) => (
						<Route
							key={i}
							exact
							path={`${data.url}`}
							element={data.component}
						/>
					))}
				</Route>
			</Routes>
			<ScrollToTop />
		</>
	);
};

function MainLayout() {
	return (
		<div id="main-wrapper overflow-auto" className={`show `}>
			<Nav />
			<div
				className="content-body"
				style={{ minHeight: window.screen.height - 260 }}>
				<div className="container-fluid">
					<Outlet />
				</div>
			</div>
		</div>
	);
}

export default Markup;
